module.exports = __webpack_public_path__ + "img/color_jp.ec114fb.jpg";